import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=56ac037c&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"
import style0 from "./Reports.vue?vue&type=style&index=0&id=56ac037c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac037c",
  null
  
)

export default component.exports